// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

export enum NoResultsVariant {
    Search = 'Search',
    Files = 'Files',
    ChannelSearch = 'ChannelSearch',
    Mentions = 'Mentions',
    FlaggedPosts = 'FlaggedPosts',
    PinnedPosts = 'PinnedPosts',
    ChannelFiles = 'ChannelFiles',
    ChannelFilesFiltered = 'ChannelFilesFiltered',
    UserGroups = 'UserGroups',
    UserGroupMembers = 'UserGroupMembers',
    UserGroupsArchived = 'UserGroupsArchived',
}

export enum NoResultsLayout {
    Vertical,
    Horizontal,
}
